var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.916,
    height: 19.851,
    viewBox: "0 0 28.916 19.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .Card_a {\n                fill: #069ad9;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-711.355 -168.663)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Card_a",
    d: "M741.335,189.3h-6.227a1.262,1.262,0,0,1-1.006-.5l-2.432-3.247a.677.677,0,0,0-.535-.271L727,185.247a1.253,1.253,0,0,1-.962-.456,2.36,2.36,0,0,1-.009-3.382,1.261,1.261,0,0,1,.91-.39h5.327a.675.675,0,0,0,.674-.674v-.152a1.259,1.259,0,0,1,1.257-1.257h2.337a1.248,1.248,0,0,1,.888.369L742,183.881l-.412.412-4.577-4.578a.673.673,0,0,0-.477-.2H734.2a.675.675,0,0,0-.674.674v.152a1.259,1.259,0,0,1-1.257,1.257h-5.327a.677.677,0,0,0-.488.208,1.784,1.784,0,0,0,.037,2.612.672.672,0,0,0,.516.243l4.131.027a1.264,1.264,0,0,1,1,.5l2.432,3.247a.679.679,0,0,0,.54.271h6.227Z",
    transform: "translate(-1.734 -1.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Card_a",
    d: "M730.02,188.514H712.762a1.408,1.408,0,0,1-1.407-1.407V170.07a1.408,1.408,0,0,1,1.407-1.407h25.266a1.408,1.408,0,0,1,1.407,1.407v5.59H738.27v-5.59a.243.243,0,0,0-.243-.243H712.762a.243.243,0,0,0-.243.243v17.037a.243.243,0,0,0,.243.243H730.02Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(726.062 172.548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "Card_a",
    width: 10.676,
    height: 0.762
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Card_a",
    width: 10.676,
    height: 0.762,
    transform: "translate(0 2.581)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Card_a",
    width: 4.517,
    height: 0.762,
    transform: "translate(0 5.163)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "Card_a",
    width: 16.787,
    height: 0.761,
    transform: "translate(712.992 185.298)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713.419 172.024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Card_a",
    d: "M718.656,172.5a2.283,2.283,0,0,0-1.68.678,2.632,2.632,0,0,0-.7,1.8,2.66,2.66,0,0,0,.7,1.841,2.321,2.321,0,0,0,1.68.727,2.154,2.154,0,0,0,1.728-.776,2.456,2.456,0,0,0,.7-1.792,2.628,2.628,0,0,0-.7-1.8A2.244,2.244,0,0,0,718.656,172.5Z",
    transform: "translate(-716.277 -172.5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Card_a",
    d: "M718.363,178.453a4.7,4.7,0,0,0-4.652,4.045h9.3A4.7,4.7,0,0,0,718.363,178.453Z",
    transform: "translate(-713.711 -173.239)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/CardIcon.fa2e38ea8fc917c43a61ec880520fc43.svg";
export { ForwardRef as ReactComponent };